import { SET_ACTIVE_MODAL } from "../../../constants/ModalConstants";

export default function setActiveModalAction(activeModal: number) {
    return {
        type: SET_ACTIVE_MODAL,
        activeModal
    };
}
